import React from 'react';
import { Tooltip } from 'react-tippy';
import { TooltipContent } from 'Settings/FirstUsageSettings/styles';
import { IconWrapper } from 'Settings/Section/styles';
import { ApButtonIcon, ApIcon, colors } from '@alixpartners/ui-components';
import { Backdrop, ModalContainer, ModalHeader } from './components.styles';

const SKUModal = ({ children, onClose, title }) => {
	return (
		<Backdrop>
			<ModalContainer>
				<ModalHeader>
					<div>
						<span style={{ display: 'flex' }}>
							{title}&nbsp;{' '}
							<Tooltip
								position="bottom"
								animation="fade"
								arrow
								html={
									<TooltipContent>
										Select filters from left to right one by one. <br />
										<br />
										Apply Filter will apply the current selected filters on the
										SKU raw table.<br />
										<br />
										Clicking on Generate Analysis Module button will generate a
										tab in Segmented Data Module.
									</TooltipContent>
								}
								trigger="mouseenter"
							>
								<IconWrapper>
									<ApIcon
										iconName="baseline_help"
										iconSize={16}
										iconColor={colors.grey6}
									/>
								</IconWrapper>
							</Tooltip>
						</span>{' '}
					</div>
					<ApButtonIcon
						title="Close"
						iconName="close"
						onClick={() => onClose(false)}
					/>
				</ModalHeader>
				{children}
			</ModalContainer>
		</Backdrop>
	);
};

export default SKUModal;
